import React, { Component } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import Serverurl from './Apiurl';
import logoImg from './images/logo.png';
import bgImage from './images/LOGIN-SCREEN-DOODLE.png';
import './styles/styles.css';  
import Typography from '@mui/material/Typography';
import Input from '@mui/material/Input';
import faceImg from './images/FACE-ID.png';       
import fingerprintImg from './images/FINGER-PRINT.png'; 

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cu_emailid: '',
      cu_password: '',
      errorMsg: '',
      redirect: false,
      pagename: '',
      showPassword: false,
      checked: true,
      open: false,
    };
  }

  componentDidMount() {
    const savedEmail = localStorage.getItem("DCUsername");
    const savedPassword = localStorage.getItem("DCpwd");

    if (savedEmail && savedPassword) {
      this.setState({
        cu_emailid: savedEmail,
        cu_password: savedPassword,
        checked: true
      });
    }
  }

  handleClickShowPassword = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handleChange = (event) => {
    this.setState({ checked: event.target.checked });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { cu_emailid, cu_password, checked } = this.state;
    const remail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

    if (cu_emailid.trim() === '') {
      this.setState({ errorMsg: "Please Enter Email Id", open: true });
      window.scrollTo({ top: 0 });
      return;
    }

    if (!remail.test(cu_emailid)) {
      this.setState({ errorMsg: "Please Enter Valid Email Id", open: true });
      window.scrollTo({ top: 0 });
      return;
    }

    if (cu_password.trim() === '') {
      this.setState({ errorMsg: "Please Enter Password", open: true });
      window.scrollTo({ top: 0 });
      return;
    }

    axios.post(Serverurl + 'customer/login', { cu_emailid, cu_password })
      .then(res => {
        const { user, assignedStaff, token } = res.data;

        if (!user) {
          this.setState({ errorMsg: 'Invalid email or password.', open: true });
          window.scrollTo({ top: 0 });
          return;
        }

        if (user.cu_isactive === 1) {
          this.setState({ errorMsg: 'Access denied: You are blocked by the admin.', open: true });
          window.scrollTo({ top: 0 });
          return;
        }

        if (checked) {
          localStorage.setItem("DCUsername", cu_emailid);
          localStorage.setItem("DCpwd", cu_password);
        } else {
          localStorage.removeItem("DCUsername");
          localStorage.removeItem("DCpwd");
        }

        localStorage.setItem("DCuserid", user.cu_id || 1);
        localStorage.setItem("DCrole", user.cu_role);
        localStorage.setItem("DCname", user.cu_name);
        localStorage.setItem("DCprofile", user.cu_profileimg || "person.jpg");
		localStorage.setItem("DCtoken", token);

        if (assignedStaff && assignedStaff.length > 0) {
          localStorage.setItem("assignedStaff", JSON.stringify(assignedStaff));
        } else {
          localStorage.removeItem("assignedStaff");
        }

      if (user.cu_role === 1) {
  this.setState({
    redirect: true,
    pagename: '/Dashboard'
  });
}
else if (user.cu_role === 2) {
  this.setState({
    redirect: true,
    pagename: '/ServiceQuote'
  });
}
else if (user.cu_role === 3) {
  this.setState({
    redirect: true,
    pagename: '/InspectionBooking'
  });
}
else {
  this.setState({
    errorMsg: 'Access denied: Unknown user role.',
    open: true
  });
  window.scrollTo({ top: 0 });
}
      }).catch(error => {
        this.setState({ errorMsg: 'Login failed. Please try again.', open: true });
        window.scrollTo({ top: 0 });
      });
  };

  handleForgotPassword = () => {
    alert('');
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
    <div 
  className="logincontainer" 
  style={{
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }}
>
        <div className="loginleftSide">
          <img src={logoImg} alt="Logo" className="loginlogo" />
          <h1 className="welcome">Welcome</h1>
          <h4 className="details">Enter your details to login</h4>
        </div>

        <div className="loginrightSide">
        <div className="loginrightSideForm">
          <Collapse in={this.state.open}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => this.setState({ open: false })}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
              sx={{ mb: 2 }}
            >
              {this.state.errorMsg}
            </Alert>
          </Collapse>

          <form onSubmit={this.handleSubmit} noValidate className="loginForm">
           <div className="formGroup">
  <p>Email</p>
  <Input
    id="txtEmailPhone"
    name="cu_emailid"
    value={this.state.cu_emailid}
    onChange={(e) => this.setState({ cu_emailid: e.target.value })}
    placeholder="Enter email or phone"
    fullWidth 
  />
</div>

<div className="formGroup">
  <p>Password</p>
  <Input
    id="txtPassword"
    name="cu_password"
    value={this.state.cu_password}
    onChange={(e) => this.setState({ cu_password: e.target.value })}
    placeholder="Enter password"
    type={this.state.showPassword ? 'text' : 'password'}
    fullWidth
    endAdornment={
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={this.handleClickShowPassword}
          edge="end"
          tabIndex={-1} style={{marginRight:'10px'}}
        >
          {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    }
  />
</div>           
            <Button
              variant="contained"
              type="submit"
              className="loginButton"             
            >
              Login
            </Button>
          </form>
        </div>		
		</div>		
      </div>
    );
  }
}

export default Login;
